import { createContext, useContext } from 'react'

export const DataTableContext = createContext({})

export const DataTableProvider = ({ value = {}, children }) => {
  return (
    <DataTableContext.Provider value={value}>
      {children}
    </DataTableContext.Provider>
  )
}

export const useDataTable = () => {
  const context = useContext(DataTableContext)

  if (context === null) {
    throw new Error(
      'Attempted to call useDataTable outside the DataTable component.'
    )
  }

  return context
}
